<template>
    <EpubPreview :bookId="bookId" role="staff" :userUid="sub || ''" :source="source" @close="close" />
</template>
<script lang="ts" setup>
import axios from 'axios';
import { storeToRefs } from 'pinia';
import EpubPreview from '~/components/EpubPreview.vue';

definePage({
    meta: {
        layout: 'epub-reader',
    },
});

const auth = useAuth();
const { sub } = storeToRefs(auth);
const router = useRouter();
const route = useRoute('/staff/book/[book_id]/view-epub');
const bookId = parseInt(route.params.book_id + '') || 0;
const { data: source } = await axios.get(`/api/book/${bookId}/epub`, { responseType: 'arraybuffer' });

const close = () => {
    router.push(`/staff/book/${bookId}/edit-book`);
};
</script>
<style scoped lang="scss"></style>
